import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled, { keyframes, css as css$1 } from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { visuallyHiddenStyle } from '../../utils/visuallyHidden.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var spin = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var animation = function animation() {
  return css$1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " 1s cubic-bezier(0.24, 0.63, 0.56, 0.79) infinite"], ["", " 1s cubic-bezier(0.24, 0.63, 0.56, 0.79) infinite"])), spin);
};
var Label = styled.span(visuallyHiddenStyle);
var AnimatedBox = styled(Box)({
  animation: animation
});
var SpinnerWrapper = styled(AnimatedBox)(variant({
  variants: {
    color: {
      borderColor: "green.300",
      borderBottomColor: "grey.5",
      borderLeftColor: "grey.5",
      borderRightColor: "grey.5"
    },
    solid: {
      borderColor: "base",
      borderBottomColor: "transparent",
      borderLeftColor: "transparent",
      borderRightColor: "transparent"
    }
  }
}), variant({
  prop: "size",
  variants: {
    md: {
      width: "24px",
      height: "24px",
      borderWidth: "2px"
    },
    lg: {
      width: "48px",
      height: "48px",
      borderWidth: "3px"
    }
  }
}), function (_a) {
  var color = _a.color;
  return css({
    display: "inline-block",
    borderRadius: "100%",
    borderStyle: "solid",
    borderTopColor: color
  });
});
var Spinner = function Spinner(_a) {
  var _b = _a.label,
    label = _b === void 0 ? "Loading..." : _b,
    _c = _a.variant,
    variant = _c === void 0 ? "solid" : _c,
    _d = _a.size,
    size = _d === void 0 ? "md" : _d,
    rest = __rest(_a, ["label", "variant", "size"]);
  return React__default.createElement(SpinnerWrapper, __assign({
    size: size,
    variant: variant
  }, rest), label && React__default.createElement(Label, null, label));
};
var templateObject_1;
export { Spinner };